import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { TranscriptionEventProvider } from './domain/events/transcription_event_provider';
import { TranscriptionCommands } from './domain/transcription_commands';
import { TranscriptionRepository } from './repositories/transcription_repository';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    TranscriptionRepository,
    TranscriptionCommands,
    TranscriptionEventProvider,
  ],
})
export class TranscriptionModule {
  static forRoot(): ModuleWithProviders<TranscriptionModule> {
    return {
      ngModule: TranscriptionModule,
      providers: [
        {
          provide: TranscriptionEventProvider,
        },
        {
          provide: TranscriptionCommands,
        },
      ],
    };
  }
}
